module.exports = __webpack_public_path__ + "img/imagem.496e9f1e.png";